import { Fragment, useRef } from 'react'
import { Dialog, Transition } from '@headlessui/react'
import { ExclamationCircleIcon } from '@heroicons/react/24/solid'
import { faSpinner } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import PropTypes from 'prop-types'

export const ModalAlert = ({
  type,
  onClose,
  onAccept,
  text,
  title,
  isLoading,
}) => {
  const cancelButtonRef = useRef(null)

  return (
    <Transition.Root as={Fragment} show={true}>
      <Dialog
        as="div"
        className="relative z-40"
        initialFocus={cancelButtonRef}
        onClose={onClose}
      >
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-40 overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel
                className={
                  'relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left ' +
                  'shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:p-6'
                }
              >
                <div className="sm:flex sm:items-start">
                  <div
                    className={
                      'mx-auto flex h-12 w-12 flex-shrink-0 items-center ' +
                      'justify-center rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10'
                    }
                  >
                    <ExclamationCircleIcon
                      aria-hidden="true"
                      className={`h-6 w-6 ${
                        type === 'warning' ? `text-red-600` : 'text-yellow-600'
                      }`}
                    />
                  </div>
                  <div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
                    <Dialog.Title
                      as="h3"
                      className="text-lg font-medium leading-6 text-gray-900"
                    >
                      {title}
                    </Dialog.Title>
                    <div className="mt-2">
                      <p className="text-sm text-gray-500">{text}</p>
                    </div>
                  </div>
                </div>
                <div className="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
                  <button
                    className={
                      'inline-flex w-full justify-center rounded-md border border-transparent ' +
                      (type === 'warning'
                        ? 'bg-red-600 focus:ring-2 focus:ring-red-500 focus:ring-offset-2 hover:bg-red-700'
                        : type === 'warning2'
                          ? 'bg-yellow-600 focus:ring-2 focus:ring-yellow-500 focus:ring-offset-2 hover:bg-yellow-700'
                          : 'bg-yellow-600 focus:ring-2 focus:ring-yellow-500' +
                            ' focus:ring-offset-2 hover:bg-yellow-700') +
                      'px-4 py-2 text-base font-medium text-white shadow-sm focus:outline-none' +
                      'sm:ml-3 sm:w-auto sm:text-sm'
                    }
                    onClick={onAccept}
                    type={type !== undefined ? type : 'button'}
                  >
                    {isLoading && (
                      <span className="inset-y-0 mr-2 flex items-center">
                        <FontAwesomeIcon
                          aria-hidden="true"
                          className="h-5 w-5 animate-spin text-white group-hover:text-gray-400"
                          icon={faSpinner}
                        />
                      </span>
                    )}
                    Aceptar
                  </button>
                  <button
                    className={
                      'mt-3 inline-flex w-full justify-center rounded-md border border-gray-300 bg-white px-4 py-2 ' +
                      'text-base font-medium text-gray-700 shadow-sm focus:outline-none' +
                      ' focus:ring-2 focus:ring-indigo-500' +
                      'focus:ring-offset-2 hover:bg-gray-50 sm:mt-0 sm:w-auto sm:text-sm'
                    }
                    onClick={onClose}
                    ref={cancelButtonRef}
                    type="button"
                  >
                    Cancelar
                  </button>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  )
}
export default ModalAlert

ModalAlert.propTypes = {
  type: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  onAccept: PropTypes.func.isRequired,
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  isLoading: PropTypes.bool,
}
